import debounce from "lodash/debounce"
import Component from "../core/Component"
import PhotoSwipeLightbox from "photoswipe/lightbox"

const CLOSE_TEXTS = {
    'cs': 'ZAVŘÍT',
    'en': 'CLOSE',
}

const closeSVGString =
    `<svg xmlns="http://www.w3.org/2000/svg" width="91" height="54" fill="none">
        <circle cx="15" cy="27" r="15" fill="#F4ECE2"/>
        <path stroke="#232324" stroke-width="1.5" d="m11 23 8 8m0-8-8 8"/>
        <text fill="#F3F1ED" font-family="Roobert" font-size="16"><tspan x="40" y="32.336">${CLOSE_TEXTS[document.documentElement.lang] ?? CLOSE_TEXTS['en']}</tspan></text>
    </svg>`
const leftArrowSVGString =
    `<svg xmlns="http://www.w3.org/2000/svg" width="53" height="54" fill="none">
        <rect width="51.4" height="52.9" x=".55" y=".55" stroke="#F3F1ED" stroke-width="1.1" rx="2.45"/>
        <path stroke="#F3F1ED" stroke-width="1.4" d="M20 27h12.5m0 0L27 21.5m5.5 5.5L27 32.5"/>
    </svg>`
const rightArrowSVString =
    `<svg xmlns="http://www.w3.org/2000/svg" width="53" height="54" fill="none">
        <rect width="51.4" height="52.9" x="-.55" y=".55" stroke="#F3F1ED" stroke-width="1.1" rx="2.45" transform="matrix(-1 0 0 1 51.4 0)"/>
        <path stroke="#F3F1ED" stroke-width="1.4" d="M32.5 27H20m0 0 5.5-5.5M20 27l5.5 5.5"/>
    </svg>`

export default class Lightbox extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        this.gallery = new PhotoSwipeLightbox({
            arrowPrevSVG: rightArrowSVString,
            arrowNextSVG: leftArrowSVGString,
            closeSVG: closeSVGString,
            gallery: this.element,
            children: "a",
            mainClass: "Lightbox",
            pswpModule: () => import("photoswipe"),
            preloaderDelay: 200,
            zoom: false,
            bgOpacity: 1,
            padding: {
                bottom: 100,
                top: 100
            }
        })


        this.gallery.on('uiRegister', () => {
            this.gallery.pswp.ui.registerElement({
                name: 'custom-caption',
                order: 9,
                isButton: false,
                appendTo: 'root',
                html: 'Caption text',
                onInit: (el, pswp) => {
                    let timer = 'first'
                    const resizeCaption = () => {
                        if (timer === 'first') {
                            timer = setTimeout(() => {
                                timer = null
                                resizeCaption()
                            }, 700)
                            return
                        }

                        if (timer) {
                            return
                        }

                        const slide = this.gallery.pswp.currSlide
                        if (!slide) {
                            return
                        }

                        const content = slide?.data?.element?.title || ''
                        if (content) {
                            el.innerHTML = content
                            el.classList.add('is-active')
                            const imgHeight = parseInt(slide.zoomLevels.fit * slide.zoomLevels.elementSize.y)
                            const imgWidth = parseInt(slide.zoomLevels.fit * slide.zoomLevels.elementSize.x)
                            const gapTop =  (slide.zoomLevels.panAreaSize.y - imgHeight) / 2
                            const gapBottom = (slide.zoomLevels.panAreaSize.y - imgHeight) / 2
                            const paddingTop = this.gallery.options.padding?.top ?? 0
                            const paddingBottom = this.gallery.options.padding?.bottom ?? 0

                            el.style.top = `${paddingTop + gapTop + imgHeight}px`
                            el.style.left = `${Math.max(0, Math.ceil((slide.zoomLevels.panAreaSize.x - imgWidth) / 2))}px`
                            el.style.width = `${imgWidth}px`
                            el.style.maxHeight = `${paddingBottom + gapBottom}px`

                            // if (window.matchMedia(queries.smallWideMax).matches) {
                            //     el.style.height = `${Math.max(-1, Math.ceil((slide.zoomLevels.panAreaSize.y - parseInt(slide.zoomLevels.fit * slide.zoomLevels.elementSize.y)) / 2)) - 1}px`
                            //     el.style.bottom = `0`
                            //     el.style.left = `0`
                            //     el.style.right = `0`
                            //     el.style.width = ``
                            // } else {
                            //     el.style.height = ``
                            //     el.style.bottom = `${Math.max(-1, Math.ceil((slide.zoomLevels.panAreaSize.y - parseInt(slide.zoomLevels.fit * slide.zoomLevels.elementSize.y)) / 2)) - 1}px`
                            //     el.style.left = `${Math.max(0, Math.ceil((slide.zoomLevels.panAreaSize.x - parseInt(slide.zoomLevels.fit * slide.zoomLevels.elementSize.x)) / 2))}px`
                            //     el.style.width = `${parseInt(slide.zoomLevels.fit * slide.zoomLevels.elementSize.x)}px`
                            // }
                        } else {
                            el.innerHTML = ''
                            el.classList.remove('is-active')
                        }
                    }
                    const debouncedResizeCaption = debounce(resizeCaption, 200)

                    this.gallery.pswp.on('change', () => {
                        resizeCaption()
                    })

                    this.gallery.on('close', () => {
                        el.classList.remove('is-active')
                    })

                    window.addEventListener('resize', debouncedResizeCaption)

                    this.gallery.pswp.on('destroy', () => {
                        window.removeEventListener('resize', debouncedResizeCaption)
                    })
                },

            })
        })


        this.gallery.init()
    }
}
